exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:768px){table.table.log td:not(.status):not(.reason),table.table.log th:not(.status):not(.reason){width:26%;height:54px}table.table.log td.reason,table.table.log td.status,table.table.log th.reason,table.table.log th.status{width:11%;height:54px}}div.paginator button,div.paginator span{width:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b4f258f","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/imports/ImportLog.vue
// module id = uOLX
// module chunks = 0